import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MapService } from 'src/app/core/services/map.service';
import { IEvacuationAlertLevel } from 'src/app/models/map';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-working-status-evacuation-alert',
  templateUrl: './working-status-evacuation-alert.component.html',
  styleUrls: ['./working-status-evacuation-alert.component.css']
})
export class WorkingStatusEvacuationAlertComponent implements OnInit, OnDestroy {

  isLoading: boolean;
  noData: boolean;
  apiSubscription: Subscription;

  constructor(
    private mapService: MapService,
    private dialogRef: MatDialogRef<WorkingStatusEvacuationAlertComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IEvacuationAlertLevel[]
  ) { }

  ngOnInit(): void {
    if (this.data === undefined) {
      this.isLoading = true;
    }
    this.apiSubscription = this.mapService.getEvacuationCountryList().subscribe(response => {
      this.isLoading = false;
      if (response.message !== undefined) {
        this.noData = true;
        return;
      }
      this.data = response.payload;
    });
  }

  onClose() {
    this.dialogRef.close(this.data);
  }

  ngOnDestroy() {
    if (this.apiSubscription) {
      this.apiSubscription.unsubscribe();
    }
  }

}
